import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import {
  createStyles,
  jssPreset,
  makeStyles,
  StylesProvider,
  ThemeProvider,
  Button
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { createTheme } from 'src/theme';
import Routes from 'src/Routes';
import { THEMES } from 'src/constants';
import LoadingScreen from 'src/components/LoadingScreen';
import ErrorPage from 'src/pages/ErrorPage';
import authProvider from 'src/services/authProvider';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { Provider } from 'react-redux';
import { configureStore } from 'src/store';
import NetDocumentsAuth from 'src/components/NetDocumentsAuth';

const store = configureStore();
const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const useStyles = makeStyles(() => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%'
    },
    body: {
      height: '100%',
      width: '100%'
    },
    '#root': {
      height: '100%',
      width: '100%'
    }
  },
  snackBarDismiss: {
    color: 'white'
  }
}));

function App() {
  const classes = useStyles();
  const notistackRef = React.useRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <Provider store={store}>
      <ThemeProvider theme={createTheme({ theme: THEMES.LIGHT })}>
        <StylesProvider jss={jss}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
              ref={notistackRef}
              action={(key) => (
                <Button className={classes.snackBarDismiss} onClick={onClickDismiss(key)}>
                  Dismiss
                </Button>
              )}
            >
              <Router history={history}>
                <NetDocumentsAuth>
                  <AzureAD provider={authProvider} reduxStore={store} forceLogin>
                    {
                  ({
                    // eslint-disable-next-line no-unused-vars
                    login, logout, authenticationState, error, accountInfo
                  }) => {
                    // eslint-disable-next-line default-case
                    switch (authenticationState) {
                      case AuthenticationState.Authenticated:
                        return <Routes />;
                      case AuthenticationState.Unauthenticated:
                        return <ErrorPage />;
                      case AuthenticationState.InProgress:
                        return <LoadingScreen />;
                    }
                    return <LoadingScreen />;
                  }
                }
                  </AzureAD>
                </NetDocumentsAuth>
              </Router>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
